import { createContext, ReactNode, useContext, useMemo } from 'react';

export interface HeadingContextValue {
  level: number;
}

export const HeadingContext = createContext<HeadingContextValue>({ level: 1 });

export function useHeadingContext() {
  return useContext(HeadingContext);
}

export function HeadingContextProvider(props: { children: ReactNode }) {
  const context = useHeadingContext();

  const value = useMemo(() => {
    return { level: Math.min(context.level + 1, 6) };
  }, [context]);

  return (
    <HeadingContext.Provider value={value}>
      {props.children}
    </HeadingContext.Provider>
  );
}
